import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { Store } from 'store/storeTypes';
import PbiFilterWeeks from './PbiFilterWeeks';
import { setActiveDate } from 'actions/reportFilterActions';
import { screenWidthSelector } from 'reducers/appUserReducer';
import {
  activeReportSelector,
  endDateSelector,
  startDateSelector,
} from 'reducers/reports/filterDataReducer';
import { selectedDateSelector } from 'reducers/reports/filterStateReducer';
import {
  activePrinterEndDateSelector,
  activePrinterStartDateSelector,
} from 'reducers/systemPageReducer';
type OwnProps = {
  isMobile?: boolean;
  closeCalendarModal?: () => void;
};
const mapStateToProps = (state: Store) => {
  return {
    startDate: startDateSelector(state),
    endDate: endDateSelector(state),
    selectedDate: selectedDateSelector(state),
    screenWidth: screenWidthSelector(state),
    activeReport: activeReportSelector(state),
    activePrinterStartDate: activePrinterStartDateSelector(state),
    activePrinterEndDate: activePrinterEndDateSelector(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ setActiveDate }, dispatch);

export type PbiFilterWeeksProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  OwnProps;

export default connect(mapStateToProps, mapDispatchToProps)(PbiFilterWeeks);
